import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
/* ─────────────────────────────────────────────
   Утилиты — можно вынести в отдельный файл
───────────────────────────────────────────── */
function isWebGLAvailable() {
    try {
        const canvas = document.createElement('canvas');
        return !!(canvas.getContext('webgl') ||
            canvas.getContext('experimental-webgl'));
    }
    catch {
        return false;
    }
}
function isInAppBrowser() {
    const ua = navigator.userAgent || '';
    return (/telegram|instagram|fbav|fban|fb_iab|vk|tiktok|snapchat|twitter|linkedin/i.test(ua) ||
        !!window.TelegramWebviewProxy ||
        (navigator.standalone === false &&
            /iphone|ipad/i.test(ua) &&
            !/safari/i.test(ua)));
}
/* ─────────────────────────────────────────────
   Компонент
───────────────────────────────────────────── */
export function InAppBrowserBanner({ message = '3D‑калькулятор работает\nтолько в браузере', buttonText = 'Открыть в браузере →', url, forceShow = false, }) {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        if (forceShow || isInAppBrowser() || !isWebGLAvailable()) {
            setVisible(true);
        }
    }, [forceShow]);
    if (!visible)
        return null;
    const href = url ?? window.location.href;
    return (_jsxs("div", { style: styles.wrapper, children: [_jsx("p", { style: styles.message, children: message.split('\n').map((line, i) => (_jsxs("span", { children: [line, i < message.split('\n').length - 1 && _jsx("br", {})] }, i))) }), _jsx("a", { href: href, target: "_blank", rel: "noopener noreferrer", style: styles.button, children: buttonText })] }));
}
/* ─────────────────────────────────────────────
   Стили (inline — нет зависимостей)
───────────────────────────────────────────── */
const styles = {
    wrapper: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: '#1a1a1a',
        borderTop: '3px solid #f0a830',
        padding: '16px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
        fontFamily: "'PT Sans', sans-serif",
        boxSizing: 'border-box',
    },
    message: {
        margin: 0,
        color: '#ccc',
        fontSize: '13px',
        lineHeight: 1.4,
    },
    button: {
        background: '#f0a830',
        color: '#111',
        textDecoration: 'none',
        padding: '10px 18px',
        borderRadius: '3px',
        fontSize: '13px',
        fontWeight: 700,
        whiteSpace: 'nowrap',
        flexShrink: 0,
    },
};
